<div class="floating-viewer-overlay" (click)="closeOverlay()">

  <div
    class="floating-viewer-container"
    (click)="$event.stopPropagation()"
  >

    <!-- ================= HEADER ================= -->

  <!-- Inside viewer-header in floating-file-viewer.component.html -->
<div class="viewer-header">
  <div class="header-info">
    <span class="disbursement-id">
      Disbursement ID : {{ disbursementId }}
    </span>
    <h2>Disbursement Timeline</h2>
  </div>

  <div style="display: flex; align-items: center; gap: 8px;">
    <!-- Payment Instruction Button Trigger -->
    <button
    *ngIf="isPaymentInstructionAllowed()"
      type="button"
      class="upload-btn"
      (click)="openPaymentInstruction()"
      title="Payment Instruction"
    >
      <mat-icon>mail</mat-icon>
      <span>Payment Instruction</span>
    </button>

    <button
      type="button"
      class="close-overlay-btn"
      (click)="closeOverlay()"
      title="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<!-- Embedded DisbursDtlsComp component instance (hidden or helper reference) -->
<app-disburs-dtls-comp
  #disbursDtlsComp
  [disbursement_obj]="disbursementObj"
  style="display: none;"
>
</app-disburs-dtls-comp>


    <!-- ================= LOADING ================= -->

    <div
      class="header-loader"
      *ngIf="isLoading || isTimelineLoading"
    >
      <mat-icon class="spin-icon">refresh</mat-icon>
      Loading timeline...
    </div>


    <!-- ================= NO DATA ================= -->

    <div
      class="no-data-msg"
      *ngIf="
        !isLoading &&
        !isTimelineLoading &&
        timeline.length === 0
      "
    >
      No timeline data available.
    </div>
    

    <!-- ================= TIMELINE ================= -->

    <div
      class="timeline-wrapper"
      *ngIf="
        !isLoading &&
        !isTimelineLoading &&
        timeline.length > 0
      "
    >
    <!-- ========================================================= -->
<!-- PDA / FDA EXPENSE TABLE -->
<!-- ========================================================= -->

<div
  class="expense-table-section"
  *ngIf="
    !isLoading &&
    !isTimelineLoading &&
    !isExpenseLoading &&
    expenseData.length > 0
  "
>

  <!-- TABLE -->
  <div
    class="expense-table-wrapper"
    [class.expanded]="showAllExpenses"
  >

<table class="expense-table">

  <thead>
    <tr>
      <th>S.No</th>
      <th>Description</th>
      <th>Agent Amount (USD)</th>
    </tr>
  </thead>

  <tbody>
    <tr
      *ngFor="
        let expense of expenseData
          | slice:0:(showAllExpenses ? expenseData.length : 3);
        let i = index
      "
    >
      <!-- S.NO -->
      <td>
        {{ expense["S. No"] || i + 1 }}
      </td>

      <!-- DESCRIPTION -->
      <td>
        {{ expense.Description || '-' }}
      </td>

      <!-- AGENT AMOUNT -->
      <td>
        {{ expense["Agent Amount"] | number:'1.2-2' }}
      </td>
    </tr>
  </tbody>

  <tfoot>
    <tr style="background-color: #07376f; color: #0056b3;">
      <td colspan="2" style="font-weight: bold; text-align: right;">
        Total
      </td>
      <td style="font-weight: bold; color: #ffffff;">
        {{ totalAgentAmount | number:'1.2-2' }}
      </td>
    </tr>
  </tfoot>

</table>

  </div>


  <!-- ======================================================= -->
  <!-- VIEW MORE -->
  <!-- ======================================================= -->

  <div
    class="expense-view-more"
    *ngIf="expenseData.length > 3"
    (click)="toggleExpenseView()"
  >

    <mat-icon>
      {{ showAllExpenses ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>

    <span *ngIf="!showAllExpenses">
      Click to View More
      ({{ expenseData.length - 3 }} remaining)
      & Scroll
    </span>

    <span *ngIf="showAllExpenses">
      Click to View Less
    </span>

  </div>

</div>

      <div
        class="timeline-item"
        *ngFor="let item of timeline; let i = index"
        [ngClass]="{
          completed: item.completed,
          current: item.current,
          rejected: item.status === 'Rejected'
        }"
      >

        <!-- ================= LEFT MARKER ================= -->

        <div class="timeline-marker">

          <div class="marker-circle">

            <mat-icon *ngIf="item.completed">
              {{
                item.status === 'Rejected'
                  ? 'close'
                  : 'check'
              }}
            </mat-icon>

            <!-- Marker Circle: Displays step number accurately in reversed order -->
<span *ngIf="!item.completed">
  {{ timeline.length - i }}
</span>

          </div>

          <div
            class="vertical-line"
            *ngIf="i < timeline.length - 1"
          ></div>

        </div>


        <!-- ================= STATUS CONTENT ================= -->

        <div class="timeline-content">

          <!-- STATUS INFORMATION -->

          <div class="status-section">

            <div class="status-main">

              <div class="status-title-row">

                <h3>
                  {{ item.title }}
                </h3>

                <span
                  class="status-badge"
                  [ngClass]="getStatusClass(item)"
                >
                  {{ getStatusText(item) }}
                </span>

              </div>


              <div
                class="status-meta"
                *ngIf="item.date || item.updatedBy"
              >

                <span *ngIf="item.date">
                  <mat-icon>schedule</mat-icon>
                  {{ item.date }}
                </span>

                <span *ngIf="item.updatedBy">
                  <mat-icon>person</mat-icon>
                  {{ item.updatedBy }}
                </span>

              </div>

              <!-- STEP AMOUNT DISPLAY (UNDER TIME) -->
              <div class="timeline-amount-meta" *ngIf="item.completed">
                
                <!-- PDA Uploaded: Port Agent PDA Amount -->
                <span 
                  class="amount-pill" 
                  *ngIf="item.title.toLowerCase().includes('pda uploaded') && item.portagent_pda_amount != null"
                >
                  <mat-icon>payments</mat-icon>
                  Estimated PDA: ${{ Math.round(item.portagent_pda_amount) | number:'1.0-0' }}
                </span>

                <!-- PDA Approved: Actual PDA Amount -->
                <span 
                  class="amount-pill" 
                  *ngIf="item.title.toLowerCase().includes('pda approved') && item.actual_pda_amount != null"
                >
                  <mat-icon>verified</mat-icon>
                  Actual PDA: ${{ Math.round(item.actual_pda_amount) | number:'1.0-0' }}
                </span>

                <!-- FDA Uploaded: Port Agent FDA Amount -->
                <span 
                  class="amount-pill" 
                  *ngIf="item.title.toLowerCase().includes('fda uploaded') && item.portagent_fda_amount != null"
                >
                  <mat-icon>payments</mat-icon>
                  Estimated FDA: ${{ Math.round(item.portagent_fda_amount) | number:'1.0-0' }}
                </span>

                <!-- FDA Approved: Actual FDA Amount -->
                <span 
                  class="amount-pill" 
                  *ngIf="item.title.toLowerCase().includes('fda approved') && item.actual_fda_amount != null"
                >
                  <mat-icon>verified</mat-icon>
                  Actual FDA: ${{ Math.round(item.actual_fda_amount) | number:'1.0-0' }}
                </span>

              </div>


              <!-- REMARKS -->

              <div
                class="timeline-remarks"
                *ngIf="item.remarks"
              >
                {{ item.remarks }}
              </div>

            </div>
<!-- STEP COMMENTS SECTION -->
<div class="client-comment-section" *ngIf="item.comments && item.comments.length > 0">
  <div class="client-comment" *ngFor="let cmt of item.comments">
    <mat-icon>comment</mat-icon>

    <div class="client-comment-content">
      <div class="client-comment-header">
        <span class="client-comment-author">{{ cmt.author }} ({{ cmt.role }})</span>
        <span class="client-comment-date" *ngIf="cmt.date_time">{{ cmt.date_time }}</span>
      </div>

      <span class="client-comment-text" [title]="cmt.comment">
        {{ cmt.comment }}
      </span>
    </div>
  </div>
</div>

<!-- ================= ATTACHMENTS SECTION ================= -->
<div class="timeline-attachments">

  <!-- 1. APPROVED STEPS: SHOW DOWNLOAD REPORT ONLY -->
  <ng-container *ngIf="item.title === 'Pda Approved' || item.title === 'Fda Approved'; else regularAttachments">
    
    <!-- IF STEP IS COMPLETED: SHOW REPORT DOWNLOAD BUTTON -->
    <div class="approved-report-container" *ngIf="item.completed">
      <div class="report-download-card">
        <div class="report-info">
          <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
          <div class="report-text">
            <span class="report-title">{{ item.title.startsWith('Pda') ? 'PDA' : 'FDA' }} Report</span>
            <span class="report-subtitle">Generated System PDF</span>
          </div>
        </div>

        <button
          type="button"
          class="download-report-btn"
          [disabled]="downloadingReportStep === item.title"
          (click)="downloadReport(item.title.startsWith('Pda') ? 'PDA' : 'FDA', item)"
          title="Download Report"
        >
          <mat-icon *ngIf="downloadingReportStep === item.title" class="spin-icon">
            refresh
          </mat-icon>
          <mat-icon *ngIf="downloadingReportStep !== item.title">
            download
          </mat-icon>

          <span>
            {{ downloadingReportStep === item.title ? 'Downloading...' : 'Download' }}
          </span>
        </button>
      </div>
    </div>

    <!-- IF STEP IS NOT COMPLETED -->
    <div class="no-attachments" *ngIf="!item.completed">
      Report available upon approval.
    </div>

  </ng-container>


  <!-- 2. ALL OTHER STEPS: KEEP UPLOAD & ATTACHMENTS LIST ACTIVE -->
  <ng-template #regularAttachments>

    <!-- HEADER WITH ATTACHMENTS COUNT & UPLOAD BUTTON -->
    <div class="attachments-header" style="display: flex; justify-content: space-between; align-items: center;">
      <div style="display: flex; align-items: center; gap: 6px;">
        <mat-icon>attach_file</mat-icon>
        <span>Attachments ({{ item.attachments.length || 0 }})</span>
      </div>

      <!-- Hidden File Input -->
      <input
        #fileInput
        type="file"
        style="display: none"
        (change)="onFileSelected($event, item)"
      />

      <!-- Upload Button -->
      <button
        type="button"
        class="upload-btn"
        (click)="fileInput.click()"
        [disabled]="isUploading"
        title="Upload File"
      >
        <mat-icon>upload_file</mat-icon>
        <span>Upload</span>
      </button>
    </div>

    <!-- ATTACHMENT LIST -->
    <div class="attachment-list" *ngIf="item.attachments?.length">
      <div class="attachment-item" *ngFor="let file of item.attachments">
        <div class="attachment-file-icon">
          <mat-icon>{{ getFileIcon(file.name) }}</mat-icon>
        </div>

        <div class="attachment-info">
          <div class="attachment-name" [title]="file.name">{{ file.name }}</div>
          <div class="attachment-size" *ngIf="file.size">{{ file.size }}</div>
        </div>

        <div class="attachment-actions">
          <button
            type="button"
            class="attachment-action-btn"
            [disabled]="!canPreview(file)"
            (click)="viewFile(file)"
            title="Preview"
          >
            <mat-icon>visibility</mat-icon>
          </button>

          <button
            type="button"
            class="attachment-action-btn"
            (click)="downloadFile(file)"
            title="Download"
          >
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- NO ATTACHMENTS MSG -->
    <div class="no-attachments" *ngIf="!item.attachments || item.attachments.length === 0">
      No attachments uploaded yet.
    </div>

  </ng-template>

</div>

          </div>

        </div>

      </div>

    </div>
      <!-- ========================================================= -->
<!-- RAISE A DISPUTE -->
<!-- ========================================================= -->

<!-- ========================================================= -->
<!-- RAISE A DISPUTE FORM -->
<!-- ========================================================= -->
<div class="raise-dispute-wrapper">

  <!-- COLLAPSED TRIGGER -->
  <div
    class="raise-dispute-trigger"
    *ngIf="!showDisputeForm"
    (click)="openDisputeForm()"
  >
    <mat-icon class="disputeIcon">report_problem</mat-icon>
    <span>Raise a Dispute</span>
    <mat-icon class="trigger-arrow">keyboard_arrow_down</mat-icon>
  </div>

  <!-- EXPANDED FORM -->
  <div class="raise-dispute-form" *ngIf="showDisputeForm">

    <div class="dispute-form-header">
      <div class="dispute-title">
        <mat-icon>report_problem</mat-icon>
        <div>
          <h3>Raise a Dispute</h3>
          <p>Select one or more steps and provide the dispute details.</p>
        </div>
      </div>

      <button
        type="button"
        class="dispute-close-btn"
        (click)="closeDisputeForm()"
        [disabled]="isDisputeSubmitting"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- HORIZONTAL STEP TRACKER -->
    <div class="step-tracker-scroll-container">
      <div class="step-tracker-horizontal">
        <div
          class="step-tracker-item"
          *ngFor="let step of disputeSteps; let last = last"
          [class.selected]="step.selected"
          (click)="toggleStepSelection(step)"
        >
          <div class="step-node-wrapper">
            <div class="step-node">
              <mat-icon *ngIf="step.selected">check</mat-icon>
              <span *ngIf="!step.selected">{{ step.index }}</span>
            </div>
            <div class="step-line" *ngIf="!last"></div>
          </div>
          <span class="step-label" [title]="step.title">{{ step.title }}</span>
        </div>
      </div>
    </div>

    <!-- STEP INPUT CARDS (SCROLLABLE AREA) -->
    <div class="selected-steps-container" *ngIf="getSelectedDisputeSteps().length > 0">
      <div
        class="step-dispute-card"
        *ngFor="let step of getSelectedDisputeSteps()"
      >
        <div class="step-card-header">
          <span class="step-badge">Step {{ step.index }}</span>
          <span class="step-card-title">{{ step.title }}</span>
        </div>

        <!-- ONLY REMARKS TEXTAREA -->
        <div class="custom-input-group">
          <label>Dispute Remarks / Reason <span class="required">*</span></label>
          <textarea
            class="custom-textarea"
            [(ngModel)]="step.reasonInput"
            rows="3"
            maxlength="2000"
            placeholder="Enter dispute remarks for {{ step.title }}..."
          ></textarea>
          <div class="char-count">
            {{ step.reasonInput.length || 0 }}/2000
          </div>
        </div>
      </div>
    </div>

    <!-- ACTION BUTTONS (ALWAYS VISIBLE AT BOTTOM) -->
    <div class="dispute-actions">
      <button
        type="button"
        class="dispute-cancel-btn"
        (click)="closeDisputeForm()"
        [disabled]="isDisputeSubmitting"
      >
        Cancel
      </button>

      <button
        type="button"
        class="dispute-submit-btn"
        (click)="raiseDispute()"
        [disabled]="!isDisputeFormValid() || isDisputeSubmitting"
      >
        <mat-icon *ngIf="!isDisputeSubmitting">send</mat-icon>
        <mat-icon *ngIf="isDisputeSubmitting" class="spin-icon">refresh</mat-icon>
        <span>
          {{ isDisputeSubmitting ? 'Sending...' : 'Send Dispute' }}
        </span>
      </button>
    </div>

  </div>

</div>
  </div>

</div>
